'use client'
import React, { Fragment, memo, useEffect, useState } from 'react'
import { Section } from '../../parts/section'
import Link from 'next/link'
import { Contact } from '../../parts/contact'
import { Figure } from '../../parts/figure'
import { Flex } from '../../parts/flex'
import { Heading } from '../../parts/heading'
import { Intro } from '../../parts/intro/Intro'
import { Service } from '@/types/newt/service'
import { ColumnM60Service } from '@/components/parts/column-m60-service'
import { BoxService } from '@/components/parts/box-service'

interface ServiceArchiveTemplateProps {
  services: Service[]
  totalServices: number
}

export const ServiceArchiveTemplate: React.FC<ServiceArchiveTemplateProps> =
  memo(({ services }) => {
    const [guideServices, setGuideServices] = useState<Service[]>([])
    const [usefulServices, setUsefulServices] = useState<Service[]>([])

    useEffect(() => {
      const guides = services
        .filter((item) => item.serviceCategory === 'LAWGUEの活用ガイド')
        .sort(
          (a, b) =>
            new Date(a.overwriteCreatedAt).getTime() -
            new Date(b.overwriteCreatedAt).getTime()
        )
        .reverse()

      const useful = services
        .filter((item) => item.serviceCategory === 'お役立ち資料')
        .sort(
          (a, b) =>
            new Date(a.overwriteCreatedAt).getTime() -
            new Date(b.overwriteCreatedAt).getTime()
        )
        .reverse()

      setGuideServices(guides)
      setUsefulServices(useful)
    }, [services])

    return (
      <>
        <Intro
          title="お役立ち資料"
          lead="LAWGUEの活用ガイドや導入事例集、<br>実務に役立つ資料集をダウンロードできます"
        />
        <div id="archive">
          <Section padding="lg:pt-32 lg:pb-32 py-16 px-6">
            <Heading
              Tag="h2"
              size="text-4xl"
              spsize="text-xl lg:text-4xl"
              textColor="textblack"
            >
              LAWGUEの活用ガイド
            </Heading>
            <ColumnM60Service>
              {guideServices.map((service, index) => (
                <Fragment key={service.slug}>
                  <BoxService thumnail={false}>
                    <Link
                      href={`/service/${service.slug}`}
                      className="block thumbnail_hover"
                    >
                      <Flex flex="flex flex-col-reverse">
                        <div>
                          <div className="mt-3">
                            <Heading
                              Tag="h3"
                              size="text-base"
                              textalign="text-center"
                            >
                              {service.title}
                            </Heading>
                          </div>
                        </div>
                        <Figure
                          thumnail={true}
                          images={service.eyecatch.src}
                          active="thumnail_etc rounded-lg"
                        />
                      </Flex>
                    </Link>
                  </BoxService>
                </Fragment>
              ))}
            </ColumnM60Service>
          </Section>

          <Section padding="pt-0 pb-16 lg:pb-32 px-6">
            <Heading
              Tag="h2"
              size="text-4xl"
              spsize="text-xl lg:text-4xl"
              textColor="textblack"
            >
              お役立ち資料
            </Heading>
            <ColumnM60Service>
              {usefulServices.map((service, index) => (
                <Fragment key={service.slug}>
                  <BoxService thumnail={false}>
                    <Link
                      href={`/service/${service.slug}`}
                      className="block thumbnail_hover"
                    >
                      <Flex flex="flex flex-col-reverse">
                        <div>
                          <div className="mt-3">
                            <Heading
                              Tag="h3"
                              size="text-base"
                              textalign="text-center"
                            >
                              {service.title}
                            </Heading>
                          </div>
                        </div>
                        <Figure
                          thumnail={true}
                          images={service.eyecatch.src}
                          active="thumnail_etc rounded-lg"
                        />
                      </Flex>
                    </Link>
                  </BoxService>
                </Fragment>
              ))}
            </ColumnM60Service>
          </Section>
        </div>
        <Contact bg="bg-lawguebase" />
      </>
    )
  })

ServiceArchiveTemplate.displayName = 'ServiceArchiveTemplate'
